import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

function TermsModal({ OpenTermsModel, showTermsModel }) {
  return (
    <div
      className={`w-full h-full bg-model fixed top-0 left-0 justify-center items-center z-40 ${
        OpenTermsModel ? 'flex' : 'hidden'
      }`}
    >
      <div className='  md:w-2/4 md:h-75 model-res bg-white md:rounded-lg p-4 md:relative'>
        <div className=' flex justify-end model-p'>
          <button onClick={showTermsModel}>
            <CloseIcon alt='exsit' style={{ color: 'black' }} />
          </button>
        </div>
        <div>
          <p className='text-center text-xl py-2'>شروط الخدمه والاحكام</p>
        </div>
        <div className='flex justify-center pb-4'>
          <div
            id='fake_textarea'
            className=' terms-height overflow-y-scroll border-2 rounded-lg focus:outline-none text-black text-right text-sm p-3  w-24rem'
          >
            اولاً: إشتراك المستخدمين
            <br /> يتوجب على المستخدم التسجيل في موقع نبيل قبل التمتع بخصائص
            المستخدمين، وذلك عن طريق تزويد الموقع بالمعلومات الشخصية. ولا يقبل
            الموقع اي طريقة اخرى <br />
            للإشتراك. ثانياً: سجل النشاطات يتيح موقع نبيل إستخدام سجل النشاطات
            الخاص لكل مستخدم بعد الاشتراك، حيث يتمكن المستخدم من اضافة البطاقات
            المختارة لحسابه الخاص اضافةً الى تصفح المعلومات الاضافية للبطاقات
            الخاصة بالمحتاجين المتواجدة في الواجهة الرئيسية. ثالثاً: مسؤولية
            توصيل الاحتياجات يتحمل المستخدم المتطوع لتلبية الاحتياج المختار وبعد
            اضافته لسجل النشاطات، كافة التبعات الاخلاقية والقانونية لغرض توصيل
            الاحتياجات للمحتاجين لها. على ان يؤكد اتمام عملية المساعدة عن طريق
            سجل النشاطات او حذف البطاقة نهائيا من السجل. رابعاً: سرية وخصوصية
            المستخدم يتعهد موقع نبيل بمصداقيته بشأن معلومات المستخدمين (الإسم،
            البريد الاكتروني، رقم الهاتف، المحافظة و اسم ورقم المنظمة)، وان هذه
            المعلومات لن يساء استخدامها ولن يتم بيعها او عرضها لأي جهة اخرى.
            خامساً: إنهاء حساب المستخدم يحق لموقع نبيل إنهاء حساب المستخدم بدون
            إشعار مسبق، واللجوء الى القضاء (إن توجب الأمر) في الحالات التالية:
            ادخال معلومات خاطئة او مظللة من قبل المستخدم اثناء عملية التسجيل سوء
            استخدام الخدمة من قبل المستخدم اكتشاف انشطة قرصنة او فعاليات غير
            طبيعية مشاركة المستخدم الخارجة عن السياقات على صفحات التواصل
            الاجتماعي الخاصة بموقع نبيل. سادساً: علاقة المستخدم بالموقع يعمل
            موقع نبيل باتقان للحفاظ على علاقة مهنية وحضارية عالية مع المستخدمين
            كافة من خلال الالتزام بسياسة الاستخدام والخصوصية. يتمنى موقع نبيل
            التزام المستخدمين بهذه السياسات واخلاقيات العمل ايضاً. علماً ان هذه
            السياسات تنطبق ايضا على مشاركات المستخدمين على مواقع التواصل
            الاجتماعي.  سياسة الخصوصية أولاً: تجميع بيانات المستخدمين يقوم موقع
            نبيل بفرض عملية الإشتراك أو التسجيل على المستخدم لغرض تقديم الخدمات
            بالصورة الصحيحة و لضمان الدقة في عمل الخدمة. وخلال عملية التسجيل،
            يقوم موقع نبيل بسؤال المستخدمين عن المعلومات التالية: الإسم البريد
            الالكتروني رقم الموبايل المحافظة اسم ورقم المنظمة ثانياً: الغرض من
            البيانات يحتاج موقع نبيل بيانات المستخدم لأجل: إنشاء حساب خاص لكل
            مستخدم يفصل نشاطه عن باقي المستخدمين تخصيص سجل نشاطات لكل مستخدم
            يفصل اختياراته ومسؤولياته عن باقي اختيارات المستخدمين عرض الاحتياجات
            تبعاً لموقع المستخدم اولاً ثالثاً: إستخدام ال(كوكيز) بعكس الكثير من
            المواقع الألكترونية، خدمة نبيل لا تستخدم تقنية ال(كوكيز) إلا لخزن
            معلومات التسجيل و تسهيل عملية دخول المستخدم الى حسابه الخاص على منصة
            موقع نبيل.
          </div>
        </div>
        <div className='flex justify-center pb-2'>
          <button
            onClick={showTermsModel}
            className='blue-bg border text-white rounded-lg p-2 w-40 focus:outline-none'
          >
            تم
          </button>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
